import { Image } from "@nextui-org/react";

function Logo() {
  return (
    <Image
      className="block object-cover"
      width={100}
      src="../../faviconLogo.svg"
      alt="Vanessa Martin Logo"
    />
  );
}

export default Logo;
